"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var style_utils_1 = require("@nef/style-utils");
var FontAwesomeIcon_1 = require("../../../FontAwesomeIcon");
var Text_1 = __importDefault(require("../../../Text"));
var innerFunction = react_1.default.forwardRef(function (_a, ref) {
    var active = _a.active, as = _a.as, rtl = _a.rtl, props = __rest(_a, ["active", "as", "rtl"]);
    var Tag = as || "button";
    return react_1.default.createElement(Tag, __assign({ type: "button" }, props, { active: String(active), ref: ref }));
});
innerFunction.displayName = "innerFunction";
var PopoverButtonWrapper = styled_components_1.default(innerFunction)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  background: ", ";\n  border: none;\n  box-sizing: border-box;\n  width: 100%;\n  font-size: 1rem;\n  text-align: left;\n  outline: none;\n  font-family: ", ";\n  color: ", ";\n  position: relative;\n\n  /* add margin following icon */\n  i {\n    ", "\n  }\n\n  ", " {\n    color: ", ";\n  }\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  :hover {\n    ", " {\n      color: ", ";\n    }\n  }\n\n  ", ";\n\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  background: ", ";\n  border: none;\n  box-sizing: border-box;\n  width: 100%;\n  font-size: 1rem;\n  text-align: left;\n  outline: none;\n  font-family: ", ";\n  color: ", ";\n  position: relative;\n\n  /* add margin following icon */\n  i {\n    ",
    "\n  }\n\n  ", " {\n    color: ", ";\n  }\n\n  ", ";\n\n  ",
    ";\n\n  ",
    ";\n\n  :hover {\n    ", " {\n      color: ", ";\n    }\n  }\n\n  ",
    ";\n\n  ",
    ";\n"])), style_utils_1.setPadding("y", 2), style_utils_1.setPadding("x", 4), style_utils_1.setDisplay("flex"), style_utils_1.setAlignItems("center"), style_utils_1.getColor("gray", 0), style_utils_1.getFont("sansSerif"), style_utils_1.getColor("gray", 900), function (props) {
    return props.rtl
        ? styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            margin-left: 0.714rem;\n          "], ["\n            margin-left: 0.714rem;\n          "]))) : styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            margin-right: 0.714rem;\n          "], ["\n            margin-right: 0.714rem;\n          "])));
}, FontAwesomeIcon_1.StyledFontAwesomeIcon, style_utils_1.getColor("gray", 800), style_utils_1.dropdownActionStates(), function (props) {
    return props.disabled && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      ", " {\n        color: ", ";\n      }\n    "], ["\n      ", " {\n        color: ", ";\n      }\n    "])), Text_1.default, style_utils_1.getColor("gray", 400));
}, function (props) {
    return !props.disabled && styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      :active,\n      :focus {\n        ", " {\n          font-weight: 500;\n        }\n      }\n    "], ["\n      :active,\n      :focus {\n        ", " {\n          font-weight: 500;\n        }\n      }\n    "])), Text_1.default);
}, FontAwesomeIcon_1.StyledFontAwesomeIcon, style_utils_1.getColor("gray", 900), function (props) {
    return props.active && styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      ", " {\n        font-weight: 500;\n      }\n    "], ["\n      ", " {\n        font-weight: 500;\n      }\n    "])), Text_1.default);
}, function (props) {
    return props.rtl && styled_components_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      direction: rtl;\n      text-align: right;\n    "], ["\n      direction: rtl;\n      text-align: right;\n    "])));
});
PopoverButtonWrapper.displayName = "PopoverButtonWrapper";
exports.default = PopoverButtonWrapper;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=index.js.map